<template>
  <div>
    <template v-if="worldO">
      <div class="world-info font-family-glegoo sm">
        <div class="server-list justify-space-between">
          <ServerStatusBox v-for="{ index, value } in worldO.logins" :key="index" :index="index" :value="value"
            >Login</ServerStatusBox
          >
        </div>
        <div class="server-list">
          <ServerStatusBox v-for="{ index, value } in worldO.hubs" :key="index" :index="index" :value="value"
            >Cross World</ServerStatusBox
          >
        </div>
        <div v-for="(group, index) in gameServers" :key="index" class="server-list justify-space-between">
          <ServerStatusBox v-for="{ index, value } in group" :key="index" :index="index" :value="value">
            Channel
          </ServerStatusBox>
        </div>
      </div>
      <div class="updated-by font xs">
        Updated by :
        {{
          new Intl.DateTimeFormat(navigator.language, {
            dateStyle: 'full',
            timeStyle: 'long',
          }).format(new Date(worldO.logDate))
        }}
      </div>
    </template>
  </div>
</template>
<script setup lang="ts">
  import { IWorldStatus } from '@/store/ServerStatus'
  import { computed, PropType } from 'vue'
  import { useDisplay } from 'vuetify'

  const { navigator } = window
  const { mobile, width } = useDisplay()

  const props = defineProps({
    worldO: {
      type: Object as PropType<IWorldStatus | null>,
      default: () => null,
    },
  })

  const gameServers = computed(
    () =>
      props.worldO?.games.reduce((acc, cur, ind) => {
        if (ind % (mobile.value === true ? (width.value < 450 ? 3 : 4) : 5)) {
          acc[acc.length - 1].push(cur)
        } else {
          acc.push([cur])
        }
        return acc
      }, [] as any) ?? []
  )
</script>

<style lang="scss" scoped>
  .world-info {
    display: flex;
    flex-direction: column;
    font-weight: bold;
    background-color: #fdfdfd;
    border-top: 1px solid var(--border-color);
  }
  .server-list {
    border-top: 1px solid var(--border-color);
    padding: 0 20px;
    display: flex;
    &:nth-child(even) {
      background-color: #f9f9fb;
    }
    &:first-child {
      width: 40%; // login servers
      border: none;
    }
    &:last-child {
      border-bottom: 1px solid var(--border-color);
    }
  }
  .updated-by {
    height: 40px;
    display: flex;
    align-items: center;

    &::before {
      content: '';
      width: 8px;
      height: 3px;
      background-color: #a0bee0;
      border-radius: 3px;
      margin-right: 6px;
    }
  }
  @media #{$tablet} {
    :deep(.server-status) {
      padding: 0 pxToRemTablet(10);
    }
    .world-info {
      font-size: max(pxToRemTablet(18), 12px);
    }
    :deep(.server-status) {
      .status-index {
        width: max(pxToRemTablet(28), 17px);
      }
      .server-status-icon {
        width: max(pxToRemTablet(20), 12px);
      }
    }
  }
  @media #{$mobile} {
    .server-list {
      padding: 0 pxToRemMobile(10);
    }
    :deep(.server-status) {
      padding: 0 pxToRemMobile(8);
    }
    .world-info {
      font-size: 12px;
    }
    :deep(.server-status) {
      .status-index {
        width: 17px;
      }
      .server-status-icon {
        width: 12px;
      }
    }
  }
</style>
